import { render, staticRenderFns } from "./NaoxjStockSale.vue?vue&type=template&id=457bf94e&scoped=true&"
import script from "./NaoxjStockSale.vue?vue&type=script&lang=js&"
export * from "./NaoxjStockSale.vue?vue&type=script&lang=js&"
import style0 from "./NaoxjStockSale.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NaoxjStockSale.vue?vue&type=style&index=1&id=457bf94e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457bf94e",
  null
  
)

export default component.exports